var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app page",class:{ 'c-dark-theme': _vm.darkMode }},[_c('CWrapper',[_c('InfoToast'),_c('div',{staticClass:"c-body"},[_c('main',{staticClass:"c-main p-0"},[_c('child')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }